// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7060) return "static/chunks/7060-62157b3c7dd2c8b1.js";
	if (chunkId === 6279) return "static/chunks/6279-5b103f93fc6fd813.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5492":"ce74f18fa43ca5fd","9682":"93e723cc58b02f2e"}[chunkId] + ".js";
};